import { render, staticRenderFns } from "./CircularMailActionCell.vue?vue&type=template&id=aa023af0&scoped=true&"
import script from "./CircularMailActionCell.vue?vue&type=script&lang=babel&"
export * from "./CircularMailActionCell.vue?vue&type=script&lang=babel&"
import style0 from "./CircularMailActionCell.vue?vue&type=style&index=0&id=aa023af0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa023af0",
  null
  
)

export default component.exports